module.exports = __webpack_public_path__ + "img/LM_map.20bc3174.svg";